'use client'

import dynamic from 'next/dynamic'
import React from 'react'

import Form from '@/components/Form/Organisms/SurveyForm/Form'
import FormLogic from '@/components/Form/Organisms/SurveyForm/Form/FormLogic'
import NpsFormLogic from '@/components/Form/Organisms/SurveyForm/Form/NpsFormLogic'

const SurveyFormFetchLogic = dynamic(() => import('@/components/Form/Organisms/SurveyForm/Fetch'), {
  ssr: false,
})

export default function SurveyForm({
  symbol,
  afterSubmit = null,
  nps = false,
  lineIdToken = null,
  liffId = null,
}: {
  symbol: string
  afterSubmit?: (() => void) | null
  nps?: boolean
  lineIdToken?: string | null
  liffId?: string | null
}) {
  const tmpAfterSubmit = afterSubmit

  return (
    <>
      <SurveyFormFetchLogic symbol={symbol}>
        {(survey, afterSubmit) => {
          return (
            <Form
              survey={survey}
              lineIdToken={lineIdToken}
              liffId={liffId}
              afterSubmit={() => {
                afterSubmit()
                if (tmpAfterSubmit != null) {
                  tmpAfterSubmit()
                }
              }}
              FormComponent={nps ? NpsFormLogic : FormLogic}
            />
          )
        }}
      </SurveyFormFetchLogic>
    </>
  )
}
